import { FlowTypeSelector, } from "../../models";
export const GetCountryDetailAsDropdownOption = (countryDetails) => {
    const countryDetailsOptions = [];
    countryDetails.map((countryDetail) => {
        countryDetailsOptions.push({
            key: countryDetail.id,
            text: countryDetail.name,
        });
    });
    return countryDetailsOptions;
};
export const GetProductDetailsAsDropdownOption = (productDetails) => {
    const productDetailsOptions = [];
    productDetails.map((productDetail, index) => {
        const product = productDetail.productName;
        const parentProduct = product.startsWith(productDetail.parentProductName + " - ")
            ? productDetail.parentProductName + " - "
            : product.startsWith(productDetail.parentProductName + "  - ")
                ? productDetail.parentProductName + "  - "
                : productDetail.parentProductName + " – ";
        const actualProductName = product.startsWith(parentProduct)
            ? product.slice(parentProduct.length)
            : product;
        productDetailsOptions.push({
            key: index,
            text: actualProductName,
            title: productDetail.productName,
        });
    });
    return productDetailsOptions;
};
export const GetSpecialProgramsDropdownOption = (programDetails) => {
    const programDetailsOptions = [];
    const excludedStrings = [
        "Commerce/Volume Licensing",
        "LicenseQ",
        "Post Sales Seller Support Team",
        "Privacy/Compliance/Audit",
        "Partner Program",
        "Retail Purchase",
        "Software Assurance Benefit",
        "Fastrack",
        "Customer Program",
        "FastTrack",
        "Escalation Compass",
        "EscalationCompass",
    ];
    programDetails.forEach((programDetail, index) => {
        if (excludedStrings.every((str) => { var _a; return !((_a = programDetail.parentProgramName) === null || _a === void 0 ? void 0 : _a.includes(str)); })) {
            programDetailsOptions.push({
                key: index,
                text: programDetail.programName,
                title: programDetail.parentProgramId +
                    "$$" +
                    programDetail.parentProgramName,
            });
        }
    });
    return programDetailsOptions;
};
export const GetPartnerPrograms = (programDetails) => {
    const partnerPrograms = [];
    programDetails.forEach((programDetail, index) => {
        if (programDetail.parentProgramName === "Partner Program") {
            partnerPrograms.push({
                key: index,
                text: programDetail.programName,
                title: programDetail.parentProgramId +
                    "$$" +
                    programDetail.parentProgramName,
            });
        }
    });
    return partnerPrograms;
};
export const GetCustomerPrograms = (programDetails) => {
    const customerPrograms = [];
    programDetails.forEach((programDetail, index) => {
        if (programDetail.parentProgramName === "Customer Program") {
            customerPrograms.push({
                key: index,
                text: programDetail.programName,
                title: programDetail.parentProgramId +
                    "$$" +
                    programDetail.parentProgramName,
            });
        }
    });
    return customerPrograms;
};
export const GetProgramDetailsAsDropdownOption = (programDetails) => {
    const programDetailsOptions = [];
    programDetails.map((programDetail, index) => {
        programDetailsOptions.push({
            key: index,
            text: programDetail.programName,
            title: programDetail.parentProgramId + "$$" + programDetail.parentProgramName,
        });
    });
    return programDetailsOptions;
};
export const GetPrivacyComplianceProgramsDropdownOption = (programDetails) => {
    const programDetailsOptions = [];
    const includeStrings = ["Privacy/Compliance/Audit"];
    programDetails.forEach((programDetail, index) => {
        if (includeStrings.every((str) => { var _a; return (_a = programDetail.parentProgramName) === null || _a === void 0 ? void 0 : _a.includes(str); })) {
            programDetailsOptions.push({
                key: index,
                text: programDetail.programName,
                title: programDetail.parentProgramId +
                    "$$" +
                    programDetail.parentProgramName,
            });
        }
    });
    return programDetailsOptions;
};
export const GetPurchasingChannelAsDropdownOption = (purchasingChannel) => {
    const purchasingChannelOptions = [];
    purchasingChannel.map((x) => {
        purchasingChannelOptions.push({ key: x.value, text: x.agreementtype });
    });
    return purchasingChannelOptions;
};
export const GetCaseSourceAsDropdownOption = (caseSource) => {
    const caseSourceOptions = [];
    caseSource.map((x) => {
        caseSourceOptions.push({ key: x.caseSourceId, text: x.casesourceName });
    });
    return caseSourceOptions;
};
export const GetAsCustomerFilterDropdownOption = () => {
    const customerOptions = [
        { key: "AccountName", text: "Company Name like " },
        { key: "TopParentIdNumber", text: "TPID = " },
        { key: "MSSalesID", text: "MSSalesID = " },
        { key: "AccountManagerAlias", text: "AccountExecutiveAlias = " },
        { key: "CountryName", text: "Country = " },
        { key: "SalesAccountNumber", text: "Account Number = " },
    ];
    return customerOptions;
};
export const GetPartnerAsFilterDropdownOption = () => {
    const partnerOptions = [
        { key: "PartnerName", text: "PartnerName like " },
        { key: "PartnerId", text: "PartnerId = " },
        { key: "CountryName", text: "CountryName = " },
        { key: "ParentId", text: "ParentId = " },
    ];
    return partnerOptions;
};
export const GetProductAsHierarichalDropdownOption = (products) => {
    const parentPrIds = Array.from(new Set(products.map((x) => x.parentProductId)));
    const dropdownOptions = parentPrIds.map((x) => {
        const dropdownValues = products.filter((y) => y.parentProductId === x);
        const productOption = {
            key: `${x}`,
            text: dropdownValues[0].parentProductName || "",
            disabled: true,
            options: dropdownValues.map((y) => {
                const product = y.productName;
                const parentProduct = product.startsWith(y.parentProductName + " - ")
                    ? y.parentProductName + " - "
                    : product.startsWith(y.parentProductName + "  - ")
                        ? y.parentProductName + "  - "
                        : y.parentProductName + " - ";
                const actualProductName = product.startsWith(parentProduct)
                    ? product.slice(parentProduct.length)
                    : product;
                const option = {
                    key: "0",
                    text: "",
                };
                if (y.productId) {
                    option.key = `${y.productId}`;
                    option.text = actualProductName;
                    option.title = y.productName;
                    option.disabled = false; // Ensure child nodes are selectable
                    option.data = {
                        parentProductName: dropdownValues[0].parentProductName || "",
                        parentProductId: `${x}`,
                    };
                    return option;
                }
                else
                    return option;
            }),
        };
        return productOption;
    });
    return dropdownOptions;
};
const getProgramListToInclude = (flowType) => {
    switch (flowType) {
        // Returning the parent program to be set in the dropdown.
        case `${FlowTypeSelector.VLM365Azure}`:
            return [
                "Software Assurance Benefit",
                "Commerce/Volume Licensing",
                "LicenseQ",
            ];
        case `${FlowTypeSelector.PCA}`:
            return ["Privacy/Compliance/Audit"];
        case `${FlowTypeSelector.ELP}`:
            return [
                "FastTrack",
                "Other - Program Not Listed",
                "Subscriptions/Program",
                "Partner Program",
                "Retail Purchase",
                "LicenseQ",
                "Brexit",
                "Tiger Team",
            ];
    }
    return [];
};
export const GetProgramAsHierarichalDropdownOption = (programs, 
// Optional parameter to filter dropdown options.
flowType = "", overRideProgram = false) => {
    const programDetailsOptions = [];
    const parentPrIds = Array.from(new Set(programs.map((x) => x.parentProgramId)));
    const dropdownOptions = parentPrIds.map((x) => {
        const dropdownValues = programs.filter((y) => y.parentProgramId === x);
        const programOption = {
            key: `${x}`,
            text: dropdownValues[0].parentProgramName || "",
            options: dropdownValues.map((y) => {
                const option = {
                    //Adding this to avoid type issues
                    key: "0",
                    text: "",
                };
                if (y.programId) {
                    option.key = `${y.programId}`;
                    option.text = y.programName;
                    option.title = y.parentProgramId + "$$" + y.parentProgramName;
                    option.data = {
                        parentProgramName: dropdownValues[0].parentProgramName || "",
                        parentProgramId: `${x}`,
                    };
                    return option;
                }
                else
                    return option; //Adding this to return but it won't be used anywhere.
            }),
        };
        return programOption;
    });
    // Filtering dropdown options from the list
    // The options to be selected has to be added to the list.
    if (overRideProgram) {
        const filterOptions = getProgramListToInclude(flowType);
        dropdownOptions.forEach((programDetail) => {
            filterOptions.forEach((option) => {
                var _a;
                if ((_a = programDetail === null || programDetail === void 0 ? void 0 : programDetail.text) === null || _a === void 0 ? void 0 : _a.includes(option))
                    programDetailsOptions.push(programDetail);
            });
        });
        return programDetailsOptions;
    }
    return dropdownOptions;
};
export const GetLicenseQSubProgramAsDropdownOption = (programs) => {
    const licenseQDropdownOptions = [];
    programs.map((x) => {
        if (x.parentProgramName === "LicenseQ") {
            licenseQDropdownOptions.push({
                key: x.programId,
                text: x.programName,
                data: {
                    parentProgramName: x.parentProgramName,
                    parentProgramId: x.parentProgramId,
                },
            });
        }
    });
    return licenseQDropdownOptions;
};
export const GetProductQuestionaireAsDropdownOption = (productQuestionaire) => {
    const questionaireDropdownOptions = [];
    productQuestionaire.map((item) => {
        var _a, _b;
        questionaireDropdownOptions.push({
            key: (_a = item.parentProductQuestionnaireOptionId) !== null && _a !== void 0 ? _a : "",
            text: (_b = item.questionOptionText) !== null && _b !== void 0 ? _b : "",
            data: item,
        });
    });
    return questionaireDropdownOptions;
};
